import PropTypes from 'prop-types';
import { useFieldArray } from 'react-hook-form';

import { Button } from '#/modules/commonComponents/button';
import InspectionConditionItemCard from
  '#/modules/imsMgmt/settings/inspectionKind/components/InspectionConditionItemCard';
import { createEmptyInspectionItem } from '#/modules/imsMgmt/settings/inspectionKind/helper/mapInspectionKindForm';

function itemsErrorMessage(errors) {
  const items = errors?.items;
  if (!items || Array.isArray(items)) {
    return items?.root?.message || '';
  }
  return items.message || items.root?.message || '';
}

const InspectionConditionItemsEditor = ({
  control,
  register,
  errors,
  setValue,
  getValues,
  knownDataTypes,
  readOnly = false,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'items',
  });
  const message = itemsErrorMessage(errors);

  return (
    <div className="form-section @container/form-section w-full">
      <div className="form-section__header flex flex-wrap items-center justify-between gap-2">
        <h2 className="form-block__title mb-0!">條件項目</h2>
        {readOnly ? null : (
          <Button
            type="button"
            size="sm"
            onClick={() => append(createEmptyInspectionItem())}
          >
            新增條件
          </Button>
        )}
      </div>
      {readOnly ? null : (
        <p className="mt-2 text-sm text-muted-foreground">
          儲存會發布下一版。從畫面上拿掉的條件不會出現在下一版。
        </p>
      )}
      {message ? <p className="form_error">{message}</p> : null}
      {readOnly && fields.length === 0 ? (
        <p className="mt-3 text-sm text-muted-foreground">這個版本沒有條件。</p>
      ) : null}
      {fields.map((field, index) => (
        <InspectionConditionItemCard
          key={field.id}
          index={index}
          control={control}
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          knownDataTypes={knownDataTypes}
          readOnly={readOnly}
          canRemove={!readOnly && fields.length > 1}
          onRemove={() => remove(index)}
        />
      ))}
    </div>
  );
};

InspectionConditionItemsEditor.propTypes = {
  control: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  setValue: PropTypes.func.isRequired,
  getValues: PropTypes.func.isRequired,
  knownDataTypes: PropTypes.object,
  readOnly: PropTypes.bool,
};

export default InspectionConditionItemsEditor;
